import { render, staticRenderFns } from "./CitationBatchReview.vue?vue&type=template&id=5d36a0ff"
import script from "./CitationBatchReview.vue?vue&type=script&lang=js"
export * from "./CitationBatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports